import { useCallback } from 'react';
import { useAppDispatch } from './core';
import {
  pushModal,
  replaceModal,
  popModal,
  clearModals,
} from '../slices/modalSlice';
import { ModalType } from '../../components/modals';

export const useModal = () => {
  const dispatch = useAppDispatch();

  const open = useCallback(
    (modalType: ModalType, modalProps?: Record<string, any>) => {
      dispatch(pushModal({ modalType, modalProps }));
    },
    [dispatch],
  );

  /**
   * Open a destination modal: replaces any open modal of the same type
   * rather than stacking another copy on top of it (gdn-2957).
   */
  const openAsDestination = useCallback(
    (modalType: ModalType, modalProps?: Record<string, any>) => {
      dispatch(replaceModal({ modalType, modalProps }));
    },
    [dispatch],
  );

  const close = useCallback(() => {
    dispatch(popModal());
  }, [dispatch]);

  const clearAll = useCallback(() => {
    dispatch(clearModals());
  }, [dispatch]);

  return {
    open,
    openAsDestination,
    close,
    clearAll,
  };
};
